module.exports = __webpack_public_path__ + "img/SLG.a3332c53.svg";